import { render, staticRenderFns } from "./BrowseBuilding2men-2.vue?vue&type=template&id=632307bc&"
import script from "./BrowseBuilding2men-2.vue?vue&type=script&lang=js&"
export * from "./BrowseBuilding2men-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports